import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 5C1.44772 5 1 5.44772 1 6C1 6.55228 1.44772 7 2 7H4.66147L2.66147 11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H7V17C7 17.5523 7.44772 18 8 18H9V20.5C9 21.0523 9.44772 21.5 10 21.5C10.5523 21.5 11 21.0523 11 20.5V18H13V20.5C13 21.0523 13.4477 21.5 14 21.5C14.5523 21.5 15 21.0523 15 20.5V18H16C16.5523 18 17 17.5523 17 17V13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H21.3385L19.3385 7H22C22.5523 7 23 6.55228 23 6C23 5.44772 22.5523 5 22 5H2ZM16.6615 7H13.3385L14.8385 10H15.1615L16.6615 7ZM10.6615 7H7.33853L8.83853 10H9.16147L10.6615 7ZM6 7.67705L7.30296 10.283C7.11609 10.4647 7 10.7188 7 11H4.33853L6 7.67705ZM12 7.67705L10.8385 10H13.1615L12 7.67705ZM9 12H15V16H9V12ZM17 11C17 10.7188 16.8839 10.4647 16.697 10.283L18 7.67705L19.6615 11H17Z",
		fill: "currentColor"
	})
});
export default SvgBc;
